import { ModalFormComponent, type ModalFormComponentCtx } from '../../components/modal.form/modal.form.component';
import { Spinner } from '../../components/spinner/spinner';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { Services } from '../../services';
import { AppStore } from '../../store';
import { OrgDepartmentSelector } from '../org.department.selector/org.department.selector';
import { CSS, Style } from './form.share.modal.style';

addStyles(Style);

export class FormShareModal extends ModalFormComponent {
	private formRevision: string;
	private departmentSelector: OrgDepartmentSelector;

	constructor(ctx: ModalFormComponentCtx, formRevision: string) {
		super(ctx);
		this.formRevision = formRevision;
		this.departmentSelector = new OrgDepartmentSelector();
		this.addState(this.departmentSelector.inputState);
	}

	get nodes(): MithrilVNode {
		const formSummary = AppStore.FormSummary.get(this.formRevision);
		if (formSummary == null) {
			return Spinner.view();
		}

		return m('div', { className: CSS.container }, [
			m('div', { className: CSS.content }, [
				m('p', Translate(T.FORM_SHARE_CONFIRM, { name: formSummary.displayname })),
				this.departmentSelector.view(),
			]),
		]);
	}

	override async submit(): Promise<any> {
		const selectedDepartmentId = this.departmentSelector.selectedDepartmentId;
		if (selectedDepartmentId == null) {
			return null;
		}

		return Services.Form.share(this.formRevision, selectedDepartmentId);
	}
}
